import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RequestOptions } from '@angular/http';
import { HttpClientModule } from '@angular/common/http';

import { AuthGuard } from './auth.guard';
import { ApplicationNotificationService } from '../application-notification.service';
import { MaterialDesignModule } from '../material-design/material-design.module';
import { HqGuard } from './hq.guard';
import { StoreGuard } from './store.guard';

@NgModule({
  imports: [
    CommonModule,
    HttpClientModule,
    MaterialDesignModule,
  ],
  providers: [AuthGuard,
    ApplicationNotificationService,
    AuthGuard, HqGuard, StoreGuard,
  ]
})
export class AuthModule { }



// WEBPACK FOOTER //
// /app/src/app/shared/auth/auth.module.ts